<template>
  <span v-if="referenceCode">
    <slot name="prepend" />
    <a
      v-if="referenceCode.url"
      target="_blank"
      :href="referenceCode.url"
      :class="{
        'event-reference-code': true,
        'force-current-color': forceCurrentColor,
        'link-force-style': !forceCurrentColor
      }"
      @click.prevent="openLink"
    >
      {{ referenceCode.code }}
    </a>
    <span
      v-else
      :class="{
        'event-reference-code': true,
        'force-current-color': forceCurrentColor
      }"
      >{{ referenceCode.code }}</span
    >
  </span>
</template>
<script>
import { defineComponent, computed, toRef } from "vue";
import gql from "fraql";

export default defineComponent({
  name: "AppShowEventReferenceCode",
  props: {
    event: {
      type: Object,
      required: true
    },
    forceCurrentColor: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const event = toRef(props, "event");
    const referenceCode = computed(() => {
      if (event.value.externalReferenceCode) {
        return {
          code: event.value.externalReferenceCode,
          url: event.value.externalUrl
        };
      } else if (event.value.referenceCodeForDisplay) {
        return {
          code: event.value.referenceCodeForDisplay,
          url: event.value.referenceCodeUrl
        };
      }
      return null;
    });

    function openLink() {
      window.open(referenceCode.value.url);
    }
    return { referenceCode, openLink };
  },
  fragments: {
    eventFields: gql`
      fragment _ on Event {
        id
        externalReferenceCode
        externalUrl
        referenceCodeForDisplay
        referenceCodeUrl
      }
    `
  }
});
</script>
<style lang="scss" scoped>
.event-reference-code {
  font-size: 14px;
}
.link-force-style {
  color: var(--v-accent-base) !important;
  &:hover,
  &:focus {
    color: var(--v-accent-base) !important;
    text-decoration: underline !important;
  }
}

.force-current-color {
  color: currentColor !important;
}
</style>
